import {useSyncExternalStore} from "react";

const hasFocus = () => typeof document !== "undefined" && document.hasFocus();

function subscribe(cb: () => void) {
  window.addEventListener("focus", cb);
  window.addEventListener("blur", cb);
  return () => {
    window.removeEventListener("focus", cb);
    window.removeEventListener("blur", cb);
  };
}

const useWindowFocus = () => {
  return useSyncExternalStore(subscribe, hasFocus);
};

export default useWindowFocus;
